import { Box, Typography } from '@mui/material';
import { OnboardingCompanyProgress } from 'constants/OnboardingCompanyProgress';
import { OnboardingTileProps } from 'modules/dashboard/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import theme from 'theme';
import {
  GENERAL__COMPLETED,
  ONBOARDING__ADD_EMPLOYEES,
  ONBOARDING__APPROVE_COLLABORATION_AGREEMENT,
  ONBOARDING__AWAITING_PAYROLL_CONFIRMATION_TEXT,
  ONBOARDING__CREATE_CONTRACTS,
  ONBOARDING__FUTURE_TASKS,
  ONBOARDING__GETTING_STARTED,
  ONBOARDING__OPEN_TASKS,
  ONBOARDING__SUBMIT_PAYROLL_INFO,
} from 'translations/constants';
import OnboardingTileGraph from './OnboardingTileGraph';
import {
  OnboardingTasksContainer,
  OnboardingTileContainer,
  OnboardingTileTaskCard,
  OnboardingTileTopBlock,
} from './styles';

const OnboardingTile: React.FC<OnboardingTileProps> = ({ handleOpenAgreementModal, onboardingProgress }) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const getOnboardingTasks = () => {
    if (onboardingProgress === OnboardingCompanyProgress.READY_FOR_MARKUP) {
      return (
        <>
          <Typography variant="h6" color={theme.palette.primary.main} fontWeight={600}>
            {t(ONBOARDING__OPEN_TASKS)} (1)
          </Typography>
          <OnboardingTileTaskCard clickable onClick={handleOpenAgreementModal}>
            {t(ONBOARDING__APPROVE_COLLABORATION_AGREEMENT)}
          </OnboardingTileTaskCard>
          <Typography variant="h6" fontWeight={600}>
            {t(ONBOARDING__FUTURE_TASKS)} (3)
          </Typography>
          <OnboardingTileTaskCard>{t(ONBOARDING__SUBMIT_PAYROLL_INFO)}</OnboardingTileTaskCard>
          <OnboardingTileTaskCard>{t(ONBOARDING__ADD_EMPLOYEES)}</OnboardingTileTaskCard>
          <OnboardingTileTaskCard>{t(ONBOARDING__CREATE_CONTRACTS)}</OnboardingTileTaskCard>
        </>
      );
    }
    if (onboardingProgress === OnboardingCompanyProgress.AWAITING_APPROVAL) {
      return (
        <>
          <Typography variant="h6" color={theme.palette.primary.main} fontWeight={600}>
            {t(ONBOARDING__OPEN_TASKS)} (1)
          </Typography>
          <OnboardingTileTaskCard clickable onClick={() => navigate('/employees')}>
            {t(ONBOARDING__ADD_EMPLOYEES)}
          </OnboardingTileTaskCard>
          <Typography variant="h6" fontWeight={600}>
            {t(ONBOARDING__FUTURE_TASKS)} (1)
          </Typography>
          {t(ONBOARDING__AWAITING_PAYROLL_CONFIRMATION_TEXT)}
          <OnboardingTileTaskCard>{t(ONBOARDING__CREATE_CONTRACTS)}</OnboardingTileTaskCard>
        </>
      );
    }
    return null;
  };

  const getOnboardingProgess = () => {
    if (onboardingProgress === OnboardingCompanyProgress.READY_FOR_MARKUP) {
      return '25%';
    }
    if (onboardingProgress === OnboardingCompanyProgress.AWAITING_APPROVAL) {
      return '85%';
    }
    return '0%';
  };

  return (
    <OnboardingTileContainer>
      <OnboardingTileTopBlock />
      <Box position="absolute" top={theme.spacing(4)} left={theme.spacing(4)} zIndex={1}>
        <Typography variant="h5" fontWeight={600} color={theme.palette.primary.contrastText}>
          {t(ONBOARDING__GETTING_STARTED)}
        </Typography>
        <Typography variant="body1" color={theme.palette.primary.contrastText}>
          {getOnboardingProgess()} {t(GENERAL__COMPLETED)}
        </Typography>
      </Box>
      <OnboardingTileGraph onboardingStatus={onboardingProgress} />
      <OnboardingTasksContainer>{getOnboardingTasks()}</OnboardingTasksContainer>
    </OnboardingTileContainer>
  );
};

export default OnboardingTile;
